import React from "react";

interface Props {
  children: React.ReactChild;
}

export default function WidgetContainer({ children }: Props) {
  return <div className="mb-8 md:mb-6">{children}</div>;
}
